"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class Service Webhook contain function to manage webhook of services
 * @public
 */
class ServiceWebhook extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list webhook in service
     * @param clientId - service client Id
     * @param page - page index
     * @param limit - num item per page
     * @returns list webhook in service
     */
    async getListWebhook(clientId, page, limit) {
        try {
            const data = await this._apiV2.webhookAPI.getListWebhook(clientId, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Create new webhook in service
     * @param clientId - service clientId
     * @param payload - create webhook payload. E.g: {name:'', content_type:'', events:[], secret:'', url:''}
     * @returns
     */
    async createWebhook(clientId, payload) {
        try {
            const data = await this._apiV2.webhookAPI.createWebhook(clientId, payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Update service webhook config
     * @param clientId - service client Id
     * @param webhookId - webhook Id
     * @param payload - update webhook payload. E.g: {status:'' ,name:'', content_type:'', events:[], secret:'', url:''}
     * @returns
     */
    async updateWebhook(clientId, webhookId, payload) {
        try {
            const data = await this._apiV2.webhookAPI.updateWebhook(clientId, webhookId, payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Delete webhook of service
     * @param clientId - service client Id
     * @param webhookId - webhook Id
     * @returns return empty response
     */
    async deleteWebhook(clientId, webhookId) {
        try {
            const data = await this._apiV2.webhookAPI.deleteWebhook(clientId, webhookId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get logs of webhook
     * @param params - paging infomation, search
     * @returns logs of webhook
     */
    async getWebhookLog(params) {
        try {
            const data = await this._apiV2.webhookAPI.getWebhookLog(params);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Retry webhook
     * @param clientId - service client Id
     * @param webhookLogId - webhook log Id
     * @returns empty result
     */
    async retryWebhook(clientId, webhookLogId) {
        try {
            const data = await this._apiV2.webhookAPI.retryWebhook(clientId, webhookLogId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ServiceWebhook;
